








































import Vue from "vue";
import Locale from "@/lib/locale";
import { singlePaymentJapanSaleList } from "./singlePaymentJapanSaleList";
import { Data, Methods, Props } from "./SalePriceGuideType";
import { ABBREVIATION_THRESHOLD_WIDTH } from "./SalePriceGuideConst";

export default Vue.extend<Data, Methods, {}, Props>({
  props: {
    fromPlanCategory: { default: undefined },
    planKey: { default: undefined },
    discountRateText: { default: undefined },
    // guideText: { default: undefined },
    originalPriceText: { default: undefined },
    salePriceText: { default: undefined }
  },
  data() {
    const saleGuide =
      this.fromPlanCategory && this.planKey
        ? singlePaymentJapanSaleList.find(
            saleGuide =>
              saleGuide.fromPlanCategory === this.fromPlanCategory &&
              saleGuide.planKey === this.planKey
          )
        : undefined;

    return {
      locale: Locale.getLocale(),
      saleGuide,
      isAbbreviationStyle: false
    };
  },
  mounted() {
    this.updateIsAbbreviationStyle();
    window.addEventListener("resize", this.updateIsAbbreviationStyle);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateIsAbbreviationStyle);
  },
  methods: {
    updateIsAbbreviationStyle() {
      const windowWidth = document.documentElement.clientWidth;
      this.isAbbreviationStyle = ABBREVIATION_THRESHOLD_WIDTH > windowWidth;
    }
  }
});
